"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visibleSwatchesCount = exports.imageSources = void 0;
var visibleSwatchesCount = exports.visibleSwatchesCount = {
  xxs: {
    min: 3,
    max: 7
  },
  xs: {
    min: 4,
    max: 8
  },
  m: {
    min: 6,
    max: 9
  },
  // A new breakpoint was needed for smaller desktop viewports as left hand nav uses a lot of the available space
  l: {
    min: 5,
    max: 8
  },
  // This breakpoint was created to display Product Card grid according to desktop design
  1350: {
    min: 7,
    max: 11
  }
};
var imageSources = exports.imageSources = [{
  media: '(max-width: 418px)',
  srcsetList: [{
    template: '180x240_standard'
  }, {
    template: '180x240_retinax2',
    scale: '1.5x'
  }, {
    template: '180x240_retinax2',
    scale: '2x'
  }]
}, {
  media: '(max-width: 527px)',
  srcsetList: [{
    template: '234x312_standard'
  }, {
    template: '234x312_retinax2',
    scale: '1.5x'
  }, {
    template: '234x312_retinax2',
    scale: '2x'
  }]
}, {
  media: '(min-width: 528px)',
  srcsetList: [{
    template: 'plp_360x480_x1'
  }, {
    template: 'plp_360x480_x2',
    scale: '1.5x'
  }, {
    template: 'plp_360x480_x2',
    scale: '2x'
  }]
}];